// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aeNy","placeholdersHeader":"styles_placeholdersHeader__CSITd","editorStyle":"styles_editorStyle__3nYfA","placeholdersBox":"styles_placeholdersBox___7iaG"};